/*
 * Description:
 * Author: zhanghj
 * Date: 2020-09-08 10:16:08
 * LastEditors: zhanghj
 * LastEditTime: 2021-01-07 13:55:00
 */
import React, { Component } from 'react';
import { Carousel } from 'antd-mobile';
import styles from './index.less';

class HomeTabbarCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 1,
    };
  }

  onChange(current) {
    this.setState({ current: current + 1 });
  }

  render() {
    const { bannerItem, autoplay, styleClass } = this.props;

    return (
      <div className={styles.carouselWrap}>
        <Carousel
          autoplay={autoplay}
          infinite
          dots={false}
          selectedIndex={0}
          style={styleClass}
          afterChange={this.onChange.bind(this)}
          dotStyle={{
            width: '.2rem',
            height: '.04rem',
            background: 'rgba(255, 255, 255, .4)',
            borderRadius: '.04rem',
            bottom: '.3rem',
          }}
          dotActiveStyle={{
            width: '.2rem',
            height: '.04rem',
            background: 'rgba(255, 255, 255)',
            borderRadius: '.04rem',
            bottom: '.3rem',
          }}
        >
          {(bannerItem ? bannerItem : []).map((val) => (
            <div key={val.id}>
              <img
                src={`${val.url}`}
                alt=""
                style={{ width: '100%', verticalAlign: 'top' }}
                onLoad={() => {
                  window.dispatchEvent(new Event('resize'));
                  this.setState({ imgHeight: 'auto' });
                }}
              />
            </div>
          ))}
        </Carousel>

        <div className={styles.page}>
          <span className={styles.current}>{this.state.current}</span>/
          <span className={styles.total}>{bannerItem && bannerItem.length}</span>
        </div>
      </div>
    );
  }
}

export default HomeTabbarCarousel;
